import Btn from './Button';
import ReactModal  from 'react-modal';
import { Link } from "react-router-dom";
import  {React, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {updateLikesCall, getWindData} from '../helpers/Utils';
import Activities from './Activities';
import {useConfig} from "../helpers/useConfig";
import { c_or_f, getIconDesc} from '../helpers/Utils';
const ForecastDay = (props) => {
    
    
   
    const [isOpen, setIsOpen] = useState(false);
    const [currentlikes, setCurrentLikes]= useState(props.likes);
    const [morningWindInfo, setMorningWindInfo]= useState();
    const [noonWindTitle, setNoonWindTitle]= useState(null);
    const [noonWindDesc, setNoonWindDesc]= useState(null);
    const [nightWindInfo, setNightWindInfo]= useState(null);
    const [currentdislikes, setCurrentDislikes] = useState(props.dislikes);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const { t } = useTranslation();
    const {configData, setConfig} = useConfig();
    let timeStringLocaleSunrise =  new Date(props.sunrise).toLocaleTimeString("he-IL", {hour: '2-digit', minute:'2-digit'});
    let timeStringLocaleSunset =  new Date(props.sunset).toLocaleTimeString("he-IL", {hour: '2-digit', minute:'2-digit'});
    let timeStringLocaleMoonrise =  new Date(props.moonrise).toLocaleTimeString("he-IL", {hour: '2-digit', minute:'2-digit'});
    let timeStringLocaleMoonset =  new Date(props.moonset).toLocaleTimeString("he-IL", {hour: '2-digit', minute:'2-digit'});
    let MoonriseAzimut = Math.round(props.moonrise_azimuth);
    let MoonsetAzimut = Math.round(props.moonset_azimuth);
    const customStyles = {
        content: {
          width:(screenWidth > 1200 ) ? '85%' :'100%',
          top: (screenWidth > 1200 ) ? '5%' :'0',
          padding:'5px',
          left: '5px',
          'overflow-x': 'hidden',
          direction: (props.lang == 1) ? 'rtl' : '',
          right: 'auto',
          bottom: '5%',          
          position: 'absolute',
          marginRight: '',
        },
      };

      const prevDay = () => {
        setTogglePrev(!togglePrev);
    
    };

    const do_something = (e) => {
        // Stop the event from propagating up to the parent div's onClick
        e.stopPropagation(); 
        console.log('Link clicked, but parent toggle was prevented.');
        // The anchor link's default behavior (navigation) will still occur
    };

      const fetchWindJson = async ()  =>  {
        try {
            const jsonWindMorning = await getWindData(props.windMorningSpd, props.lang);
            const jsonWindNoon = await getWindData(props.windDaySpd, props.lang);
            const jsonWindNight = await getWindData(props.windNightSpd, props.lang);
            
            
            console.log(props.windMorningSpd + ' ' + jsonWindMorning.windtitle + jsonWindMorning.winddesc);
            console.log(props.windDaySpd + ' ' + jsonWindNoon.windtitle + jsonWindNoon.winddesc);
            console.log(props.windNightSpd + ' ' + jsonWindNight.windtitle + jsonWindNight.winddesc);
            setMorningWindInfo(jsonWindMorning);
            setNoonWindDesc(jsonWindNoon.winddesc);
            setNoonWindTitle(jsonWindNoon.windtitle);
            setNightWindInfo(jsonWindNight);
        }
        catch  (err) {
        console.error('fetchWindJson error: ', err);
        }
        

    }

    useEffect(() => {
        if (isOpen) {
        fetchWindJson();
            }
    }, [isOpen]);

    const useToggle = (initialState) => {
        const [toggleValue, setToggleValue] = useState(initialState);
    
        const toggler = () => { setToggleValue(!toggleValue) };
        return [toggleValue, toggler]};
      const updateLikes = async (e, id, likedislike) => {
        e.stopPropagation();
        const res_vote = await updateLikesCall(id, likedislike);
        if (likedislike === "like"){
            setCurrentLikes(res_vote.likes[0].count);
            console.log('updateLikesCall: likes=' + res_vote.likes[0].count);
        }
        else {
            setCurrentDislikes(res_vote.dislikes[0].count);
            console.log('updateLikesCall: dislikes=' + res_vote.dislikes[0].count);
        }
                
    }
        
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
            //alert(window.innerWidth);

        };
        
        handleResize();
        window.addEventListener('resize', handleResize);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', handleResize);
        };
        
        }, []); // Empty dependency array means this effect runs once on mount
    
    const [toggle, setToggle] = useToggle();
    const [togglePrev, setTogglePrev] = useToggle();
    const text = eval(`props.lang${props.lang}`);
    const shortText =  text.length > 50 ? text.substring(0, 50) + "..." : text;
    if (props.yest === undefined)
      return "loading...";
    return (
        <>
       
        {props.a_key === 0 && togglePrev 
            ? 
            <ul className={"yest white_transp_box white_box box_text forecast_header " + (props.lang == 1? 'rtl' : '')}>
                <li className="forcast_day">{props.yest.date}</li>
                <li className="forcast_text"></li>
                <li className="forecast_strip_container">
                    <ul className="forecast_strip">
                        <li className="forcast_morning">{props.yest.lowtemp}°</li>
                        <li className="forcast_noon">{props.yest.noontemp}°</li>
                        <li className="forcast_night">{props.yest.nighttemp}°</li>
                    </ul>
                </li>
                <li className=" more">   </li>
            </ul>
            : ''}

        
        <ul className={"white_transp_box white_box modern box_text forecast_list  " + (props.lang == 1? 'rtl' : '') + (toggle? ' expanded ' : ' closed ')}>
             <li className="forecast_item">
                      {/* HEADER */}
                            <ul
                            className="forecast_header"
                            onClick={() => setToggle(v => !v)}
                            >
                                <li className="forcast_day">
                            {(props.a_key == 0 && !props.isPopup) && (
                                <div className="forcast_off_day">
                                <div className="spriteB up"></div>
                                <Btn btnOnClick={prevDay} img={togglePrev ? "ArrowDown" : "ArrowUp"}>
                                    <img src="images/yesterday.png" width="14" height="14" alt="" />
                                </Btn>
                                </div>
                            )}

                            <span>
                                {eval(`props.day_name${props.lang}`)} {props.date}
                            </span>
                            <a href="#" rel="external" className="info cboxElement" onClick={(e) => {e.stopPropagation();e.preventDefault();}}>
                                <span className="info">{t(getIconDesc(props.icon))}</span>
                                    <img
                                    src={`https://v2013.02ws.co.il/${props.icon}`}
                                    width="40"
                                    height="45"
                                    alt={props.date}
                                />
                            </a>
                            

                            {props.windDaySpd > 30 && (
                                <div className={`wind_icon ${props.windDay}`}></div>
                            )}
                            </li>
                            <li className="forcast_text">
                            {((screenWidth > 500) || (toggle)) && (<Link className="toggle" onClick={() => setToggle()} ><div className="extra fulltext" dangerouslySetInnerHTML={{__html: text }}></div></Link>)}
                            {(!toggle) && (screenWidth <= 500) && (<Link className="toggle" onClick={() => setToggle()} ><div className="extra shorttext" dangerouslySetInnerHTML={{__html: shortText}}></div></Link>)}
                            {(toggle) && (<div id={`divlikes${props.id}`} className="extra likedislike">		
                                    <Btn className="btn-secondary" img="HandThumbsUp" btnOnClick={(e) => updateLikes(e, props.id, 'like')} onclick="updateLikes(event, this.parentNode.parentNode.parentNode.parentNode.id, 'like');"></Btn>
                                    <span className="likes">{currentlikes}</span>&nbsp;
                                    <Btn className="btn-secondary" img="HandThumbsDown" btnOnClick={(e) => updateLikes(e, props.id, 'dislike')} onclick="updateLikes(event, this.parentNode.parentNode.parentNode.parentNode.id, 'dislike');"></Btn>
                                    <span className="dislikes">{currentdislikes}</span>
                            </div>)}
                                                                                                    
                            </li>
                            <li className="forecast_strip_container">
                                    <ul className="forecast_strip">
                                    <li className="forcast_morning">
                                        <div className="line">
                                            <div className="number">
                                                {c_or_f(props.TempLow, configData.tempUnit)}</div>
                                            {((screenWidth > 500) || (toggle)) && ( 
                                            <div className="cloth extra"> 
                                                <a href="#" rel="external" className="info cboxElement" onClick={(e) => {e.stopPropagation();e.preventDefault();}}>
                                                    <span className="info">{eval(`props.TempLowClothTitle${props.lang}`)}</span>
                                                    <img style={{'verticalAlign': 'middle'}} src={`https://v2013.02ws.co.il/${props.TempLowCloth}`} width="35" height="35" alt={eval(`props.TempLowClothTitle${props.lang}`)} />
                                                </a>
                                            </div>)}
                                        </div>
                                        {(toggle) && ( <div className="icon extra" id="morning_icon">
                                            <img src={`https://v2013.02ws.co.il/${props.morning_icon}`} width="40" height="40" alt="https://v2013.02ws.co.il/images/icons/day/n4_cloud_5_sun_3.svg" />
                                        </div>)}
                                        <div className="icon extra">
                                        {(toggle) && ( <div className={`wind_icon ${props.windMorning}`} title="">{props.windMorningSpd} <span className="paramunit">{t("KMH")}</span> </div>)}
                                        </div>
                                </li>
                                <li className="forcast_noon">
                                    <div className="line">
                                        <div className="number">
                                        {c_or_f(props.TempHigh, configData.tempUnit)}</div>
                                        {((screenWidth > 500) || (toggle)) && (
                                        <div className="cloth extra">
                                            <a href="#" rel="external" className="info cboxElement" onClick={(e) => {e.stopPropagation();e.preventDefault();}}>
                                                <span className="info">{eval(`props.TempHighClothTitle${props.lang}`)}</span>
                                                <img style={{'verticalAlign': 'middle'}} src={`https://v2013.02ws.co.il/${props.TempHighCloth}`} width="35" height="35"  alt={eval(`props.TempHighClothTitle${props.lang}`)} />
                                            </a>
                                        </div>)}
                                    </div>
                                    
                                    {(toggle) && (<div className="icon extra" id="day_icon0"><img src={`https://v2013.02ws.co.il/${props.icon}`} width="40" height="40" alt="images/icons/day/n4_cloud_5_sun_3.svg" /></div>)}                                       
                                    <div className="icon extra">
                                    {(toggle) && (<div className={`wind_icon ${props.windDay}`}> {props.windDaySpd} <span className="paramunit">{t("KMH")}</span> </div>)}
                                    <div>
                                    </div>
                                    </div>
                                </li>
                                <li className="forcast_night">
                                    <div className="line">
                                        <div className="number">
                                        {c_or_f(props.TempNight, configData.tempUnit)}</div>
                                        {((screenWidth > 500) || (toggle)) && (
                                        <div className="cloth extra">
                                            <a href="#" rel="external" className="info cboxElement" onClick={(e) => {e.stopPropagation();e.preventDefault();}}>
                                                <span className="info">{eval(`props.TempNightClothTitle${props.lang}`)}</span>
                                                <img style={{'verticalAlign': 'middle'}} src={`https://v2013.02ws.co.il/${props.TempNightCloth}`} width="35" height="35"  alt={eval(`props.TempNightClothTitle${props.lang}`)} />
                                            </a>
                                        </div>)}
                                    </div> 
                                    {(toggle) && (<div className="icon extra" id="night_icon0"><img src={`https://v2013.02ws.co.il/${props.night_icon}`} width="40" height="40" alt="https://v2013.02ws.co.il/images/icons/day/n4_moon.svg" /></div>)}
                                    <div className="icon extra">
                                    {(toggle) && (  <div className={`wind_icon ${props.windNight}`} >{props.windNightSpd} <span className="paramunit">{t("KMH")}</span> </div> )}
                                        <div></div></div>
                                </li>
                                </ul>
                            </li>
                            <li className="more">
                                <Btn btnOnClick={() => setToggle()}  img={toggle ? "ChevronUp" : "ChevronDown" } cssClasses="d-flex align-items-end" >
                                    
                                </Btn>
                                {(toggle) && (  <Btn btnOnClick={() => setIsOpen(true)}  img={"ZoomIn"}>
                                    
                                </Btn> )}
                            </li>
                        </ul>
                      {/* COLLAPSIBLE GRID PANEL */}  
                     <ul className="forecast_panel">
                        <li className="forcast_day">
                                <div className="g-col-3">
                                        <img src="https://v2013.02ws.co.il/images/icons/radiation.svg" width="30px" height="30px" alt={t("RADIATION")} />
                                        {t("SUNRISE")} {timeStringLocaleSunrise}<br/>
                                        <img src="https://v2013.02ws.co.il/images/icons/radiation.svg" width="30px" height="30px" alt={t("RADIATION")} />
                                        {t("SUNSET")} {timeStringLocaleSunset}  
                                        
                                </div>
                        </li>
                        
                        <li>
                            <div className={"g-col-3  " + (props.lang == 1? 'rtl' : '')}>
                                 <img src="https://v2013.02ws.co.il/images/icons/radiation.svg" width="30px" height="30px" alt={t("RADIATION")} />
                                 {t("VISIBILITY")} {props.visDay} {t("KM")}
                            </div>
                         </li>
                         <li >
                             <div className="g-col-3">
                                 { props.rainTo > 0 && <img src="https://v2013.02ws.co.il/images/icons/rain.svg" width="30px" height="30px" alt={t("RAIN")} />}
                                 { props.rainTo > 0 && `${props.rainFrom}  -  ${props.rainTo}    ${t("RAIN_UNIT")} ${t("RAIN")} ` }  
                             </div>               
                         </li>
                        <li className="more">
                            <Btn btnOnClick={() => setIsOpen(true)}  img={"ZoomIn"}>
                                    
                                </Btn>
                        </li>
                    
                    <li className="forecast_strip_container">
                    </li>
                   <li className="more">
                    </li>
                </ul>
            </li>
           
        </ul>
       
        <ReactModal
        
        isOpen={isOpen}
        contentLabel="Example Modal"
        style={customStyles}
        onRequestClose={() => setIsOpen(false)}

      >
        
         <Btn btnOnClick={() => setIsOpen(false)} btnTitleText={""}  img={"X"} cssClasses={(props.lang == 1? 'float-start' : 'float-end')}>
                
        </Btn>
        
        <ul id="forcast_day_popup">
             
           
         <ul className={" white_box box_text " + (props.lang == 1? 'rtl' : '')}>
                <li className="forcast_day">
                  <img src={`https://v2013.02ws.co.il/${props.icon}`} width="45" height="45" alt="9/5" verticalAlign="middle" /> {eval(`props.day_name${props.lang}`)} {props.date} 
               </li>
               <li className="forcast_text">
                    <div dangerouslySetInnerHTML={{__html: eval(`props.lang${props.lang}`)}}></div>
                    
                    <ul id="dailydata" className={"flex-column  box_text justify-content-grid-column " + (props.lang == 1? 'rtl' : '')}>
                        <li> </li>
                        <li>
                            <img src="https://v2013.02ws.co.il/images/icons/moon.svg" width="30px" height="30px" alt={t("SUNRISE")} />
                             {t("SUNRISE")} {timeStringLocaleMoonrise};{MoonriseAzimut}°   
                        </li>
                        <li> 
                            <img src="https://v2013.02ws.co.il/images/icons/moon.svg" width="30px" height="30px" alt={t("SUNSET")} />
                             {t("SUNSET")} {timeStringLocaleMoonset};{MoonsetAzimut}°               
                        </li>
                        <li>
                            <img src="https://v2013.02ws.co.il/images/icons/radiation.svg" width="30px" height="30px" alt={t("RADIATION")} />
                            {t("SUNRISE")} {timeStringLocaleSunrise}  
                        </li>
                        <li>
                            <img src="https://v2013.02ws.co.il/images/icons/radiation.svg" width="30px" height="30px" alt={t("RADIATION")} />
                            {t("SUNSET")} {timeStringLocaleSunset}
                        </li>
                        <li>
                            { props.rainTo > 0 && `${props.rainFrom}  -  ${props.rainTo}    ${t("RAIN_UNIT")} ${t("RAIN")}`}  
                        </li>
                        <li>{t("VISIBILITY")} {props.visDay} {t("KM")}</li>
                    </ul>
                                                                                        
                </li>
                <li className="daily_activities">
                    <Activities activities_json={props.activities_json} activities={props.recommendations} lang={props.lang} />
                </li>
                <li className="forecast_strip_container">
                    <ul className="forecast_strip">
                        <li className="legend">
                        <ul className="legend_container">
                                <li > 
                                    <div id={`divlikes${props.id}`} className="likedislike">		
                                        <Btn className="btn-secondary" img="HandThumbsUp" btnOnClick={(e) => updateLikes(e, props.id, 'like')} onclick="updateLikes(event, this.parentNode.parentNode.parentNode.parentNode.id, 'like');"></Btn>
                                        <span className="likes">{currentlikes}</span>&nbsp;
                                        <Btn className="btn-secondary" img="HandThumbsDown" btnOnClick={(e) => updateLikes(e, props.id, 'dislike')} onclick="updateLikes(event, this.parentNode.parentNode.parentNode.parentNode.id, 'dislike');"></Btn>
                                        <span className="dislikes">{currentdislikes}</span>
                                    </div>
                        </li>
                        <li className="humiditylbl"> {t("HUMIDITY")} </li>
                        <li className="dustlbl">  {t("DUST")} </li> 
                        </ul>
                        </li>
                        <li className="forcast_morning white_transp_box white_box">
                            <div className="line">
                                {t("MORNING")}
                            </div>
                            <div className="line">
                                    <div className="number">
                                        {c_or_f(props.TempLow, configData.tempUnit)}</div><div className="cloth extra0"> 
                                        <a href="#" rel="external" className="info cboxElement">
                                            <span className="info">{eval(`props.TempLowClothTitle${props.lang}`)}</span>
                                            <img style={{'verticalAlign': 'middle'}} src={`https://v2013.02ws.co.il/${props.TempLowCloth}`} width="35" height="35" alt={eval(`props.TempLowClothTitle${props.lang}`)} />
                                        </a>
                                    </div>
                                </div>
                                <div className="icon extra" id="morning_icon">
                                    <img src={`https://v2013.02ws.co.il/${props.morning_icon}`} width="40" height="60" alt="" />
                                </div>
                                <div className="icon extra">
                                <div className={`wind_icon ${props.windMorning}`} title="">
                                        {props.windMorningSpd} <span className="paramunit">{t("KMH")}</span> <div className="winddesc">{morningWindInfo ? `${morningWindInfo.windtitle}: ${morningWindInfo.winddesc}` : t("LOADING")}</div> 
                                </div>
                                </div>
                            <div className="extra">
                                {props.humMorning}%
                            </div>
                            <div className="extra">
                                {props.dustMorning}<span className="paramunit">{t('DUST_UNIT')}</span>   
                            </div>
                            
                        </li>

                        <li className="forcast_noon white_transp_box white_box">
                            <div className="line">
                                {t("NOON")}
                            </div>
                            <div className="line">
                                <div className="number">
                                {c_or_f(props.TempHigh, configData.tempUnit)}</div><div className="cloth extra">
                                    <a href="#" rel="external" className="info cboxElement">
                                        <span className="info">{eval(`props.TempHighClothTitle${props.lang}`)}</span>
                                        <img style={{'verticalAlign': 'middle'}} src={`https://v2013.02ws.co.il/${props.TempHighCloth}`} width="35" height="35"  alt={eval(`props.TempHighClothTitle${props.lang}`)} />
                                    </a>
                                </div>
                            </div>
                            <div className="icon extra" id="day_icon0">
                                    <img src={`https://v2013.02ws.co.il/${props.icon}`} width="40" height="60" alt="images/icons/day/n4_cloud_5_sun_3.svg" />
                            </div>
                                                                
                            <div className="icon extra">
                                <div className={`wind_icon ${props.windDay}`}> {props.windDaySpd} <span className="paramunit">{t("KMH")}</span> <div className="winddesc">{noonWindTitle ? `${noonWindTitle}: ${noonWindDesc}` : t("LOADING")}</div></div>
                            </div>
                            <div className="extra">
                            {props.humDay}%
                            </div>
                            <div className="extra">
                            {props.dustDay}<span className="paramunit">{t('DUST_UNIT')}</span>   
                            </div>
                            
                        </li>

                        <li className="forcast_night white_transp_box white_box">
                            <div className="line">
                                {t("NIGHT")}
                            </div>
                            <div className="line">
                                <div className="number">
                                {c_or_f(props.TempNight, configData.tempUnit)}</div><div className="cloth extra">
                                    <a href="#" rel="external" className="info cboxElement">
                                        <span className="info">{eval(`props.TempNightClothTitle${props.lang}`)}</span>
                                        <img style={{'verticalAlign': 'middle'}} src={`https://v2013.02ws.co.il/${props.TempNightCloth}`} width="35" height="35"  alt={eval(`props.TempNightClothTitle${props.lang}`)} />
                                    </a>
                                </div>
                            </div> 
                            
                            <div className="icon extra" id="night_icon0"><img src={`https://v2013.02ws.co.il/${props.night_icon}`} width="40" height="60" alt="" /></div>
                            <div className="icon extra">
                            <div className={`wind_icon ${props.windNight}`} >{props.windNightSpd} <span className="paramunit">{t("KMH")}</span> <div className="winddesc">{nightWindInfo ? `${nightWindInfo.windtitle}: ${nightWindInfo.winddesc}` : t("LOADING")}</div></div> 
                                <div></div>
                            </div> 
                            <div className="extra">
                                {props.humNight}%
                            </div>
                            <div className="extra">
                                {props.dustNight}<span className="paramunit">{t('DUST_UNIT')}</span>  
                            </div>
                        </li>
                    </ul>
                </li>
                
         </ul>
         

        </ul>
         
      </ReactModal>
        </>
    );
}

export default ForecastDay; 